if (!customElements.get('toylivo-recent-searches')) {
  customElements.define(
    'toylivo-recent-searches',
    class ToylivoRecentSearches extends HTMLElement {
      connectedCallback() {
        this.storageKey = this.dataset.storageKey || 'toylivo:recent-searches';
        this.list = this.querySelector('.toylivo-search-suggestions__list');
        this.render();
      }

      render() {
        if (!this.list) return;
        const terms = toylivoReadStorage(this.storageKey).slice(0, 6);

        if (terms.length === 0) {
          this.setAttribute('hidden', '');
          this.list.innerHTML = '';
          return;
        }

        this.list.innerHTML = terms
          .map(
            (term) => `
              <li>
                <a href="${this.searchUrl(term)}" class="toylivo-search-suggestions__chip">
                  ${toylivoEscapeHtml(term)}
                </a>
              </li>
            `
          )
          .join('');
        this.removeAttribute('hidden');
      }

      searchUrl(term) {
        const existingForm = document.querySelector('form[role="search"]');
        const routeBase = existingForm
          ? existingForm.getAttribute('action')
          : `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}search`;
        return `${routeBase}?q=${encodeURIComponent(term)}`;
      }

      static recordSearch(term) {
        const trimmed = (term || '').trim();
        if (!trimmed) return;

        document.querySelectorAll('toylivo-recent-searches').forEach((el) => {
          const storageKey = el.dataset.storageKey || 'toylivo:recent-searches';
          let stored = toylivoReadStorage(storageKey);
          stored = stored.filter((existing) => existing.toLowerCase() !== trimmed.toLowerCase());
          stored.unshift(trimmed);
          stored = stored.slice(0, 10);
          toylivoWriteStorage(storageKey, stored);
        });
      }
    }
  );
}

// Record a search term whenever any Dawn search form is submitted, without
// interfering with the existing predictive-search/search-form submit handlers.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (form.getAttribute('role') !== 'search') return;

  const input = form.querySelector('input[name="q"]');
  if (input && input.value.trim().length > 0) {
    const ToylivoRecentSearches = customElements.get('toylivo-recent-searches');
    if (ToylivoRecentSearches) ToylivoRecentSearches.recordSearch(input.value);
  }
});
